import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { CreditCardAccountDTO } from '@root/app/banking/data/dtos/credit-card-account-dto';
import { CreditCardAccountGridDTO } from '@root/app/banking/data/dtos/credit-card-account-grid-dto';
import { CreditCardAccountOptionDTO } from '@root/app/banking/data/dtos/credit-card-account-option-dto';
import { CreditCardAccountTransactionDTO } from '@root/app/banking/data/dtos/credit-card-account-transaction-dto';
import { PagingResultsDTO } from '@root/manager-base/data/dtos/paging-results.dto';
import {
    OutstandingBalancesForCreditCardReadDTO
} from '@app/banking/data/dtos/outstanding-balances-for-credit-card-read-dto';

const actions = {
    create: {
        method: 'POST',
        url: `${BASE_PATH_API}/creditCardAccounts`
    },
    getAll: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts`
    },
    exists: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/exists`
    },
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:id`
    },
    getAllAsOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/options`
    },
    update: {
        method: 'PUT',
        url: `${BASE_PATH_API}/creditCardAccounts/:id`
    },
    getTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/transactions`
    },
    getOutstandingBalances: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/outstandingBalances`
    },
    inactivate: {
        method: 'POST',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/inactivate`
    },
    reactivate: {
        method: 'POST',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/reactivate`
    },
    // reconciliations APIs
    getReconciliations: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/reconciliations`
    },
    getFinalizeReconciliationReport: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:id/reconciliations/finalizeReport`
    },
    getReconciliationById: {
        method: 'GET',
        url: `${BASE_PATH_API}/creditCardAccounts/:creditCardAccountId/reconciliations/:reconciliationId`
    }
};

export interface ICreditCardAccountsApi {
    create(account: CreditCardAccountDTO): Promise<CreditCardAccountDTO>
    get(params: { id: number }): Promise<CreditCardAccountDTO>
    getAll(params: any): Promise<PagingResultsDTO<CreditCardAccountGridDTO>>
    getAllAsOptions(): Promise<CreditCardAccountOptionDTO[]>
    update(params: { id: number }, account: CreditCardAccountDTO): Promise<CreditCardAccountDTO>
    getTransactions(params: any): Promise<PagingResultsDTO<CreditCardAccountTransactionDTO>>
    getOutstandingBalances(params: { id: number }): Promise<OutstandingBalancesForCreditCardReadDTO[]>
    inactivate(id: any): Promise<any>
    reactivate(id: any): Promise<any>
    getExportUrl(params: any): string
    getReconciliations(id: number): Promise<any>
    getFinalizeReconciliationReport(id: number): Promise<any>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function CreditCardAccountsApi(
    $httpParamSerializer): ICreditCardAccountsApi {
    const service = createActions(actions);

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    service.getExportUrl = function getExportUrl(params) {
        return `${BASE_PATH_API}/creditCardAccounts/export?${$httpParamSerializer(params)}`;
    };

    return service;
}

CreditCardAccountsApi.$inject = [
    '$httpParamSerializer'
];
